(function () {
  function init() {
    var wrappers = document.querySelectorAll('.faq-accordion-wrapper');
    if (!wrappers.length) return;

    function toggleTrigger(trigger) {
      if (!trigger) return;
      var contentId = trigger.getAttribute('aria-controls');
      var content = contentId ? document.getElementById(contentId) : null;
      if (!content) return;

      var isOpen = content.classList.contains('active');
      var wrapper = trigger.closest('.faq-accordion-wrapper') || document;

      wrapper.querySelectorAll('.collapsible-content.active').forEach(function (item) {
        if (item !== content) {
          item.classList.remove('active');
          item.style.maxHeight = null;
          var otherTrigger = wrapper.querySelector('[aria-controls="' + item.id + '"]');
          if (otherTrigger) {
            var otherSvg = otherTrigger.querySelector('.faq-accordion-icon svg');
            if (otherSvg) otherSvg.classList.remove('open');
            otherTrigger.setAttribute('aria-expanded', 'false');
          }
        }
      });

      if (!isOpen) {
        content.classList.add('active');
        content.style.maxHeight = content.scrollHeight + 'px';
        trigger.setAttribute('aria-expanded', 'true');
      } else {
        content.classList.remove('active');
        content.style.maxHeight = null;
        trigger.setAttribute('aria-expanded', 'false');
      }

      var svg = trigger.querySelector('.faq-accordion-icon svg');
      if (svg) svg.classList.toggle('open', !isOpen);
    }

    wrappers.forEach(function (wrapper) {
      wrapper.addEventListener('click', function (event) {
        var trigger = event.target.closest('.collapsible-trigger');
        if (trigger && wrapper.contains(trigger)) toggleTrigger(trigger);
      });

      wrapper.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        var trigger = event.target.closest('.collapsible-trigger');
        if (trigger && wrapper.contains(trigger)) {
          event.preventDefault();
          toggleTrigger(trigger);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
